<template>
  <div class="absolute md:top-9 top-4 md:left-8 left-3 z-10">
    <div class="container">
      <ol
        :class="
          cn('flex w-full space-x-1.5 max-md:overflow-auto', props.listClass)
        "
        vocab="http://schema.org/"
        typeof="BreadcrumbList"
      >
        <li
          v-for="(item, idx) in generalStore.breadcrumbs"
          :key="item.text"
          class="inline-flex z-10 items-center ui-text-xs gap-x-1 max-md:whitespace-nowrap first:before:content-[''] before:content-['>'] before:text-primary"
          :aria-current="item.disabled ? 'page' : undefined"
          property="itemListElement"
          typeof="ListItem"
        >
          <nuxt-link
            v-if="!item.disabled && item.href"
            :to="localePath(item.href)"
            property="item"
            class="underline-offset-4 hover:underline text-primary"
            typeof="WebPage"
          >
            <span property="name">{{ item.text }}</span>
          </nuxt-link>
          <button
            v-else-if="!item.disabled && item.action"
            class="text-primary"
            @click="item.action"
          >
            <span property="name">{{ item.text }}</span>
          </button>
          <span v-else property="name" class="font-bold text-primary">
            {{ item.text }}
          </span>
          <meta property="position" :content="String(idx + 1)" />
        </li>
      </ol>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from "vue";

const props = defineProps<{
  light?: boolean;
  class?: HTMLAttributes["class"];
  listClass?: HTMLAttributes["class"];
}>();

const localePath = useLocalePathPolyfill();
const generalStore = useGeneralStore();
</script>
